import React from 'react';
import CardMaster from '../../../Product/CardMaster';
import { CGCardConfigFormValues } from 'types/cardForm';
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';
import { canCustomiseWithLogo, isCustomMasterDesignCard, isCustomCardDotGiftDesignCard, isCustomEftposDesignCard, canCustomiseDesign } from 'components/CardConfigurer/configurerFlags';
import mastercardUploadDefaultimage from 'assets/cardCustomisation/customDesign/mastercardUploadDefaultimage.png';
import EftposUploadDefaultimage from 'assets/cardCustomisation/customDesign/EftposUploadDefaultimage.png';
import CardDotGiftUploadDefaultimage from 'assets/cardCustomisation/customDesign/CardDotGiftUploadDefaultimage.png';
import { STEPS, PRODUCT_HANDLE } from 'utilities/constants';
import debug from 'debug';
import Box from '@mui/system/Box';
import { formatCurrency } from 'lib/currency';
import { useProduct } from 'effects/useProduct';
const d = debug('multiCardDisplay');
interface MultiCardDisplayProps {
  defaultProductHandle: string;
  hidePrice?: boolean;
  children?: React.ReactNode;
  values: CGCardConfigFormValues;
  forceSize?: 'small' | 'medium' | 'large';
  showLogo?: boolean;
  step?: number;
  steps?: string[];
}

const MultiCardDisplay: React.FC<MultiCardDisplayProps> = ({ defaultProductHandle, forceSize, hidePrice, values, children, showLogo, step, steps }) => {
  const { product } = useProduct(values.cardDesignHandle || defaultProductHandle || undefined);

  let border = 0; // No card border...
  let displayImage;
  if (values.cardDesign === 'custom' || (product && (isCustomMasterDesignCard(product) || isCustomCardDotGiftDesignCard(product) || isCustomEftposDesignCard(product)))) {
    border = 1; // Custom design - add a border...
    if (!canCustomiseWithLogo || values.cardCustomDesignType === 'background') {
      displayImage = values.cardCustomImage?.url;
      if (values.cardCustomImage && values.cardCustomImage.url) {
        border = 0; // Have custom image - hide that border again...
      }
    }
    if (!values.cardCustomImage && step && steps && product && canCustomiseDesign(product) && steps[step] === STEPS.DESIGN) {
      switch (defaultProductHandle) {
        case PRODUCT_HANDLE.CARD_GIFT:
        case PRODUCT_HANDLE.CARDDOTGIFT_CARD_CUSTOM:
          displayImage = CardDotGiftUploadDefaultimage;
          break;
        case PRODUCT_HANDLE.EFTPOS:
        case PRODUCT_HANDLE.EFTPOS_CARD_CUSTOM:
          displayImage = EftposUploadDefaultimage;
          break;
        case PRODUCT_HANDLE.MASTER_CARD:
        case PRODUCT_HANDLE.MASTER_CARD_CUSTOM:
          displayImage = mastercardUploadDefaultimage;
          break;
        default:
          break;
      }
    }
  }
  const theme = useTheme();
  let cardSize: 'small' | 'medium' | 'large' = 'large';
  if (useMediaQuery(theme.breakpoints.down('lg'))) cardSize = 'medium';
  if (useMediaQuery(theme.breakpoints.down('md'))) cardSize = 'small';
  d('displayingItem', product);
  return (
    <>
      <Box>
        <CardMaster
          sx={{ border: border }}
          noButton
          image={displayImage}
          size={forceSize || cardSize}
          item={product}
          noShrink
          // showPrice={hidePrice ? undefined : values.cardValue}
          showLogo={showLogo}
          defaultProductHandle={defaultProductHandle}
        >
          {children ? (
            children
          ) : values.cardDesign === 'custom' && values.cardCustomDesignType === 'logo' ? (
            <div
              style={{
                width: (values.cardCustomPosition?.width || 0.2) * 100 + '%',
                height: (values.cardCustomPosition?.height || 0.2) * 100 + '%',
                left: (values.cardCustomPosition?.x || 0) * 100 + '%',
                top: (values.cardCustomPosition?.y || 0) * 100 + '%',
                position: 'absolute',
                zIndex: 0,
                backgroundImage: 'url(' + values.cardCustomImage?.url + ')',
                backgroundSize: '100% 100%',
              }}
            />
          ) : null}
        </CardMaster>
        {hidePrice ? null : (
          <Box sx={{ pt: 1.5, pr: 1, color: 'text.disabled', typography: 'subtitle1', textAlign: 'right' }}>
            Card Value: {values.cardValue ? formatCurrency(Number(values.cardValue)) : 'unavailable.'}
          </Box>
        )}
      </Box>
    </>
  );
};

export default MultiCardDisplay;
